import template from './leave_taken_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class LeaveTakenHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveTakenHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveTakenHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveTakenHelp',
	dialog_class: LeaveTakenHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_taken_help',
	provider: 'ps'
};
